import React from 'react';

function Statement() {
  return (
    <section className="statement">
      <span className="eyebrow">A note to the two of you</span>
      <p>
        Be completely, wonderfully <em>yourself.</em><br />
        We’ll take care of remembering it.
      </p>
      <span className="statement-flower" aria-hidden="true">✳</span>
    </section>
  );
}

export default Statement;
